module.exports = __webpack_public_path__ + "img/teaching.9e7b5e2e.png";